export const transformSearchFiltersForStore = (searchFiltersConfig, activeSearchFilters) =>
    searchFiltersConfig.filter(sf => activeSearchFilters[sf.uuid]);
